import React from "react";
import { FiThumbsDown, FiThumbsUp } from "react-icons/fi";
import gsap from "gsap";
import useTheme from "../../hooks/useTheme";
import { useThemes } from "../../contexts/ThemeContext";
import { IoMdRefresh } from "react-icons/io";
import ReactDOM from "react-dom";

export const PopUp = ({ type = "success", title, unmount = () => {} }) => {
  const { theme } = useTheme();
  const { themes, currentTheme } = useThemes();
  const themeT = themes[currentTheme];

  const TIME_DELAY = type === "refresh" ? 900 : 3000;

  React.useEffect(() => {
    // Animation in - slides down from above
    gsap.fromTo(".popup-container", { y: -100, opacity: 0 }, { y: 0, opacity: 1, duration: 0.5, ease: "back.out(1)" });

    // Animation out - slides back up
    setTimeout(() => {
      gsap.to(".popup-container", {
        y: -80,
        opacity: 0,
        duration: 0.5,
        ease: "back.in(1)",
        onComplete: () => unmount(),
      });
    }, TIME_DELAY);
  }, []);

  // For refresh type - animate three dots
  const [dots, setDots] = React.useState(".");
  React.useEffect(() => {
    if (type === "refresh") {
      const interval = setInterval(() => {
        setDots((prev) => (prev.length >= 3 ? "." : prev + "."));
      }, 500);
      return () => clearInterval(interval);
    }
  }, [type]);

  const content = (
    <div className="fixed left-0 right-0 top-0 flex justify-center z-[9999999999] mt-20" style={{ zIndex: 9999999999 }}>
      <div
        className={`popup-container transform -translate-y-full opacity-0 items-center text-sm ${themeT.colors.blocksBg} ${themeT.colors.navText} ${themeT.colors.dashBoardShadow} flex p-3 rounded-xl`}
      >
        <div
          className={`p-2 text-white rounded-full ${document.getElementsByTagName("html")[0].getAttribute("dir") === "ltr" ? "mr-2" : "ml-2"} ${
            type === "success" || type === "refresh" ? "bg-green-600" : "bg-red-600"
          } ${type === "refresh" && "animate-spin"}`}
        >
          {type === "success" ? <FiThumbsUp /> : type === "refresh" ? <IoMdRefresh /> : <FiThumbsDown />}
        </div>
        <p className={`${type === "success" || type === "refresh" ? "text-green-600" : "text-red-600"}`}>
          {title}
          {type === "refresh" && dots}
        </p>
      </div>
    </div>
  );

  return ReactDOM.createPortal(content, document.body);
};
